export default __webpack_public_path__ + "static/media/img1.a0ec02d7.png";